import React, { useState } from "react";
import { Grid, Container } from "@mui/material";
import SideBarLinks from "../../../shared/customers/sidebar/SideBarLinks";
import SideLinks from "../../../shared/customers/sidebar/SideLinks";
import EditProfile from "./EditProfile";
import ProfileChangePassword from "./ProfileChangePassword";
import ProfilePayMethod from "./ProfilePayMethod";
import {
  ProfileLayoutMian,
  ProfileLayoutWrap,
  ProfileContactMain,
} from "../styles/ProfileLayoutStyles";
// import { LOGOUT } from "../../../../constants/apiEndPoints";
// import { toast } from "react-hot-toast";
// import httpRequest from "../../../../axios/index";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAuthStorage,
  setRedirTo,
} from "../../../../redux/slice/user/UserSlice";
import { useNavigate } from "react-router-dom";
import { signouthandler } from "../../../../services/auth/logout";
import { SetProfileMobileSidebar } from "../../../../redux/slice/common/CommonSlice";

const ProfileLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const GetSidebarState = useSelector(
    (state) => state.common.ProfileMobileSidebar
  );
  const [selectedLink, setSelectedLink] = useState(0);

  const links = [
    { label: "Edit Profile" },
    { label: "Change Password" },
    { label: "Payment Methods" },
    { label: "Logout" },
  ];

  const handleLinkClick = async (link) => {
    if (link === 3) {
      const res = await signouthandler();
      if (res.status === 200) {
        navigate("/login");
        dispatch(setRedirTo(""));
        dispatch(clearAuthStorage());
      }
    } else {
      setSelectedLink(link);
    }
    dispatch(SetProfileMobileSidebar(!GetSidebarState));
  };
  return (
    <>
      <ProfileLayoutMian>
        <Container maxWidth="lg">
          <ProfileLayoutWrap>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3} lg={3}>
                <SideBarLinks>
                  <SideLinks
                    links={links}
                    selectedLink={selectedLink}
                    onLinkClick={handleLinkClick}
                  />
                </SideBarLinks>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <ProfileContactMain>
                  {selectedLink === 0 && <EditProfile />}
                  {selectedLink === 1 && <ProfileChangePassword />}
                  {selectedLink === 2 && <ProfilePayMethod />}
                </ProfileContactMain>
              </Grid>
            </Grid>
          </ProfileLayoutWrap>
        </Container>
      </ProfileLayoutMian>
    </>
  );
};

export default ProfileLayout;
